import { Injectable } from '@angular/core';
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';

import { LoaderComponent } from '../components/loader/loader.component';

@Injectable({
  providedIn: 'root'
})
export class McRAILoader {
  private _isAttached = false;
  private _overlayRef: OverlayRef;

  constructor(
    private _overlay: Overlay
  ) { }

  private _getConfig(): OverlayConfig {
    const config = new OverlayConfig();

    config.positionStrategy = this._overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically();

    config.hasBackdrop = true;
    config.panelClass = 'cdk-overlay-pane--fullscreen';

    return config;
  }

  private _getPortal(): ComponentPortal<LoaderComponent> {
    return new ComponentPortal(LoaderComponent);
  }

  private _attach() {
    const config = this._getConfig();
    const portal = this._getPortal();

    this._overlayRef = this._overlay.create(config);
    this._overlayRef.attach(portal);

    this._isAttached = true;
  }
  private _detach() {
    if (this._overlayRef) {
      this._overlayRef.dispose();
    }
    this._isAttached = false;
  }

  public show(): void {
    if (!this._isAttached) {
      this._attach();
    }
  }

  public hide(): void {
    if (this._isAttached) {
      this._detach();
    }
  }
}
